var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('full-calendar',{attrs:{"id":"myugcalendar","options":_vm.calendarOptions}}),_c('modal-news',{attrs:{"news-id":_vm.chosenNewsId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }